import React, {useState} from 'react';
import './Toggle.scss';
import ToggleOffIcon from '../../assets/icons/close-light-grey.svg';
import ToggleOnIcon from '../../assets/icons/checkmark-light-blue.svg';

function FoMoToggleButton({initialState = true, onToggle, testId = 'toggle-button'}) {
  const [isActive, setActive] = useState(initialState);
  const toggle = (e) => {
    e.preventDefault();
    setActive(!isActive);
    onToggle();
  };
  return (
    <button
      type='button'
      className={`btn btn-lg fomo--web--btn-toggle ${isActive ? 'btn-primary active' : 'btn-secondary'}`}
      data-toggle='button'
      aria-pressed={isActive}
      data-testid={testId}
      onClick={(e) => toggle(e)}
    >
      <div className='fomo--web-toggle-icon-container'>
        {isActive ? (
          <img className='fomo--web-toggle-on-icon' src={ToggleOnIcon} alt='toggle-on' data-testid='fomo-toggle-on' />
        ) : (
          <img className='fomo--web-toggle-off-icon' src={ToggleOffIcon} alt='toggle-off' data-testid='fomo-toggle-off' />
        )}
      </div>
    </button>
  );
}
export default FoMoToggleButton;
